import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconForward7 = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 23.594 17.91'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M23.301,8.677 L16.426,15.645 C16.234,15.839 15.983,15.937 15.731,15.937 C15.480,15.937 15.229,15.839 15.037,15.645 C14.653,15.257 14.653,14.626 15.037,14.237 L21.218,7.974 L15.037,1.710 C14.653,1.322 14.653,0.691 15.037,0.303 C15.421,-0.086 16.042,-0.086 16.426,0.303 L23.301,7.270 C23.685,7.659 23.685,8.289 23.301,8.677 ZM18.390,8.677 L11.515,15.645 C11.327,15.836 11.076,15.937 10.820,15.937 C10.694,15.937 10.566,15.912 10.444,15.861 C10.078,15.707 9.875,15.373 9.875,14.970 L9.875,11.926 C7.026,11.879 4.886,12.498 3.517,13.779 C2.030,15.172 1.982,16.871 1.980,16.942 C1.970,17.477 1.545,17.912 1.018,17.923 C1.011,17.923 1.004,17.923 0.998,17.923 C0.479,17.923 0.048,17.517 0.018,16.990 C-0.350,10.650 2.606,7.441 5.151,5.865 C6.982,4.732 8.822,4.286 9.875,4.109 L9.875,0.970 C9.875,0.568 10.078,0.241 10.444,0.087 C10.811,-0.067 11.233,0.017 11.515,0.303 L18.390,7.270 C18.774,7.659 18.774,8.289 18.390,8.677 ZM11.803,3.409 L11.803,4.988 C11.803,5.047 11.779,5.098 11.769,5.154 C11.758,5.219 11.754,5.286 11.731,5.347 C11.708,5.407 11.670,5.455 11.636,5.509 C11.602,5.564 11.575,5.620 11.531,5.667 C11.488,5.713 11.435,5.744 11.385,5.781 C11.333,5.819 11.286,5.861 11.227,5.888 C11.169,5.915 11.105,5.923 11.041,5.938 C10.986,5.951 10.937,5.978 10.879,5.981 C10.551,6.003 4.592,6.468 2.596,11.959 C4.508,10.418 7.287,9.747 10.879,9.966 C10.937,9.969 10.986,9.996 11.040,10.009 C11.104,10.024 11.170,10.032 11.228,10.060 C11.286,10.087 11.331,10.128 11.382,10.165 C11.434,10.203 11.488,10.234 11.532,10.281 C11.574,10.327 11.601,10.383 11.635,10.436 C11.669,10.491 11.708,10.541 11.731,10.602 C11.755,10.662 11.758,10.728 11.770,10.794 C11.779,10.850 11.803,10.901 11.803,10.960 L11.803,12.538 L16.307,7.974 L11.803,3.409 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconForward7.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
